module.exports = __webpack_public_path__ + "assets/c4d3d265257cc0e31f1ab2768c484a90.png";